(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new_product_comparator"] && !Shopify.designMode) return;
  try {
    
  const compareProductsElements = document.querySelectorAll('compare-products');

  if (!compareProductsElements.length) return;

  function resetComparatorHoverTitles(root) {
    for (const titlesEl of root.querySelectorAll('[data-interaction="hover"]')) {
      const defaultSpan = titlesEl.querySelector('.js-title-color-default');
      for (const span of titlesEl.querySelectorAll('.js-title-color-default, .js-title-color')) {
        span.classList.toggle('is-active', span === defaultSpan);
      }
      const label = defaultSpan?.textContent?.trim();
      if (label) titlesEl.setAttribute('aria-label', label);
    }
  }

  function setComparatorHoverTitle(titlesEl, titleKey) {
    if (!titlesEl || !titleKey) return;
    const safe = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(titleKey) : titleKey;
    for (const span of titlesEl.querySelectorAll('.js-title-color-default, .js-title-color')) {
      span.classList.remove('is-active');
    }
    // Same handle can exist on default + sibling; only one must be active (prefer sibling on hover).
    const target =
      titlesEl.querySelector(`.js-title-color.${safe}`) || titlesEl.querySelector(`.js-title-color-default.${safe}`);
    if (target) target.classList.add('is-active');
    const label = target?.textContent?.trim();
    if (label) titlesEl.setAttribute('aria-label', label);
  }

  for (const compareProducts of compareProductsElements) {
    for (const wrapper of compareProducts.querySelectorAll('.c-productColorSwatch__wrapper')) {
      const titlesEl = wrapper.querySelector('[data-interaction="hover"]');
      if (!titlesEl) continue;

      for (const btn of wrapper.querySelectorAll('.c-productColorSwatch__color')) {
        const showTitleForSwatch = () => {
          const item = btn.closest('.c-comparator__item');
          const el = item?.querySelector('[data-interaction="hover"]');
          const key = btn.dataset.titleKey;
          if (el && key) setComparatorHoverTitle(el, key);
        };

        btn.addEventListener('pointerenter', showTitleForSwatch);
        btn.addEventListener('focus', showTitleForSwatch);
      }

      wrapper.addEventListener('pointerleave', () => {
        const item = wrapper.closest('.c-comparator__item');
        if (item) resetComparatorHoverTitles(item);
      });

      wrapper.addEventListener('focusout', (e) => {
        if (wrapper.contains(e.relatedTarget)) return;
        const item = wrapper.closest('.c-comparator__item');
        if (item) resetComparatorHoverTitles(item);
      });
    }

    compareProducts.addEventListener('click', (e) => {
      const swatch = e.target.closest('.c-productColorSwatch__color');
      if (!swatch || !compareProducts.contains(swatch)) return;

      const handle = swatch.dataset.handle;
      if (!handle) return;

      const allCompareProducts = document.querySelectorAll('compare-products');

      for (const cp of allCompareProducts) {
        const lists = cp.querySelectorAll('.c-productColorSwatch__list');

        for (const list of lists) {
          const buttons = list.querySelectorAll('.c-productColorSwatch__color');

          for (const btn of buttons) {
            btn.classList.remove('active');
          }

          const match = list.querySelector(`[data-handle="${handle}"]`);
          if (match) match.classList.add('active');
        }

        const items = cp.querySelectorAll('.c-comparator__item');
        for (const item of items) {
          item.setAttribute('aria-hidden', item.dataset.handle !== handle);
        }

        resetComparatorHoverTitles(cp);
      }

      const selectedItem = compareProducts.querySelector(`.c-comparator__item[data-handle="${handle}"]`);

      const modal = document.querySelector('#productComparatorModal');
      if (modal) {
        const seeProductLink = modal.querySelector('.o-modal__footer a');
        if (seeProductLink && selectedItem?.dataset.productUrl) {
          seeProductLink.href = selectedItem.dataset.productUrl;
        }
      }

      const layout = compareProducts.closest('.c-comparator__layout');
      const label = document.querySelector('.c-comparator__compare_product dynamic-value');
      if (label && selectedItem?.dataset.productTitle) {
        label.textContent = selectedItem.dataset.productTitle;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
